import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./about.styles.css";
import Profile from "../../assets/img/profile/profilepic.jpg";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";

const About = () => {
  return (
    <div id="about">
      <div className="about">
        <h1 className="pt-3 text-center font-details pb-3">ABOUT ME</h1>
        <Container>
          <Row className="pt-3 pb-5 align-items-center">
            <Col xs={12} md={6}>
              <Row className="justify-content-center mb-2 mr-2 ">
                <Image className="profile justify-content-end" alt="profile" src={Profile} thumbnail fluid />
              </Row>
            </Col>
            <Col xs={12} md={6}>
              <Row className=" align-items-start p-2 my-details rounded">
                Hi there! I am <strong>&nbsp;Solomon Macharia,</strong>
                A self-taught web/ software developer and programmer from Nairobi, Kenya.
                I enjoy building everything from small business to rich interactive web apps. I am
                <br/>
                An experienced Web/ Software Developer adept in bringing forth expertise in design,
                installation, testing, and maintenance of software systems. 
                <br/>
                Equipped with a diverse and promising skill-set. <br/> Proficient in various platforms, languages, and
                embedded systems. 
                <br/>
                Experienced with the latest cutting edge development tools and
                procedures. 
                <br/>
                Able to effectively self-manage during independent projects, as well as
                collaborate as part of a productive team.
                <br/> <br/>
                * If you are a business looking for a web developer or an employer looking to hire, feel free to get in touch with me.
                <br/><br/>
                <Col className="d-flex justify-content-center flex-wrap">
                  <div>
                    <a href="#contact">
                      <Button className="m-2" variant="outline-primary">
                        Let's talk
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a href="https://drive.google.com/file/d/1_rRU3xHotMN7WYWSCfWL772wms6CtZaZ/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-success">
                        My Resume
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a href="https://github.com/SolomonMacharia" target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-dark">
                        GitHub
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a href="https://www.linkedin.com/in/solomon-macharia-b53114193/" target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-info">
                        LinkedIn
                      </Button>
                    </a>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default About;
